/**
 * Providers for login
 */
enum NextAuthProvidersEnum {
	FACEBOOK = 'facebook',
	MICROSOFT = 'microsoft',
	GOOGLE = 'google',
	CREDENTIALS = 'credentials',
	LINKCODE = 'linkcode',
	WALLET = 'wallet',
}

export default NextAuthProvidersEnum;
